module.exports = __webpack_public_path__ + "img/s_ele_right.6882945f.png";